<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="sayfahead m-0" :class="Kisi_id?'sayfahead-xs':''">
      <h1><small>Destek Merkezi</small></h1>
      <el-button type="success" size="small" class="YeniBtn" @click="YeniBtn">
        Destek Talebi Ekle
      </el-button>
    </div>
    <el-table
      v-if="Liste"
      :data="Liste"
      :class="Kisi_id?'table-xs':''"
      class="golgetable">
      <el-table-column
        v-if="!Kisi_id"
        label="Ad Soyad"
        prop="AdSoyad">
      </el-table-column>
      <el-table-column
        label="Başlık"
        prop="Baslik">
      </el-table-column>
      <el-table-column
        label="Durum"
        prop="DurumText">
      </el-table-column>
      <el-table-column
        align="right">
        <template slot-scope="scope">
          <el-button-group>
            <el-tooltip v-if="Yetki" class="item" effect="dark" content="Düzenle"
                        placement="top-start">
              <el-button
                size="mini"
                type="primary"
                icon="feather-edit-2"
                @click="DuzenleBtn(scope.row)">
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="Yetki" class="item" effect="dark"
                        content="Sil"
                        placement="top-start">
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete-solid"
                @click="SilOnay(scope.row.id)">
              </el-button>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <BinaDestekModal @BinaDestekModal="SayfaYukle"
                     :BinaDestekModal="BinaDestekModal"
                     v-if="BinaDestekModal"
                     :data="Data"></BinaDestekModal>
  </div>
</template>

<script>
  import Yukleniyor from "../../../../Doc/Yukleniyor";
  import BinaDestekModal from "./Toplanti/BinaDestekModal";

  export default {
    props: ['Bina_id', 'Kisi_id'],
    components: {BinaDestekModal, Yukleniyor},
    data() {
      return {
        lo: true,
        Data: {
          ModalBaslik: 'Destek Talep Ekle',
          Bina_id: this.Bina_id,
          Kisi_id: this.Kisi_id,
          tTarihi: null,
          Konu: null
        },
        Liste: null,
        BinaDestekModal: false
      }

    },
    methods: {
      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {path: 'yonetim/bina/destek/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      },
      DuzenleBtn(data) {
        data.ModalBaslik = 'Destek Talep Düzenle'
        this.Data = data;
        this.BinaDestekModal = true
      },
      YeniBtn() {
        this.Data = {
          ModalBaslik: 'Destek Talep Ekle',
          Bina_id: this.Bina_id,
          Kisi_id: this.Kisi_id,
          Konu: null
        };
        this.BinaDestekModal = true
      },
      SayfaYukle() {
        this.BinaDestekModal = false;
        this.lo = true;
        this.$store.dispatch("Get", {path: 'yonetim/bina/destek/' + this.Bina_id + '/' + this.Kisi_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;

            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },

    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.yonetim == '2' ? true : false;
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaDestek.vue